<template>
  <div>
    <v-btn @click.stop="dialog = true"
           color="primary"
    >
      <v-icon class="margin-right-small">mdi-plus-circle</v-icon>
      Add quality level
    </v-btn>
    <v-dialog v-model="dialog"
              max-width="500"
              persistent
    >
      <AddQualityLevelForm
        v-if="dialog"
        :connection="connection"
        @cancel="dialog = false"
        @ok="dialog = false"
        @encode-updated="$emit('encode-updated', $event)"
        @failure="$emit('failure', $event)"
      >
      </AddQualityLevelForm>
    </v-dialog>
  </div>
</template>

<script>
import AddQualityLevelForm from "./AddQualityLevelForm";
import { HubConnection } from "@microsoft/signalr";

export default {
  name:       "AddQualityLevel",
  components: { AddQualityLevelForm },
  props:      {
    connection: HubConnection,
  },
  data() {
    return {
      dialog: false,
    };
  },
};
</script>

<style scoped></style>
